<template>
  <div class="container-fluid">
    <div class="main-bg row min-vh-100 d-flex align-items-center justify-content-center">
      <!-- Left Part -->
      <div class="col-md-8 col-lg-8 col-xl-8 d-flex align-items-center justify-content-center">
        <div class="col-md-10 col-lg-6 col-xl-6">
          <div class="col-md-12 mb-4">
            <img :src="logoPath" alt="Company Logo" class="companyLogo mt-5" style="width: 30%;">
          </div>
          <div class="card-body text-center">
            <CompanyRegister v-if="activeStep === 1" @changeStep="setActiveStep" :type="registrationType"/>
            <UserRegister v-if="activeStep === 2" @changeStep="setActiveStep"/>
            <Subscribe v-if="activeStep === 3" @changeStep="setActiveStep"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineAsyncComponent } from 'vue';
  
  export default {
    
    data() {
      return {
        activeStep: 1,
        logoPath: require('@/assets/images/TravelDesk-white-logo.png'),
        registrationType: null,
      };
    },

    methods: {
      setActiveStep(step) {
        this.activeStep = step;
      },
    },

    components: {
      CompanyRegister: defineAsyncComponent(() =>  import('./components/CompanyRegister.vue') ),
      UserRegister: defineAsyncComponent(() =>  import('./components/UserRegister.vue') ),
      Subscribe: defineAsyncComponent(() =>  import('./components/Subscribe.vue') ),
    },
    mounted() {
      this.registrationType = this.$route.query.type;
    }
  }

  </script>

<style scoped lang="scss">
@import '@/assets/styles/variables';

/* Make sure these styles apply only to this specific view */
.container-fluid {
  min-height: 100vh; /* Minimum viewport height */
}

.companyLogo {
  height: auto !important; /* Minimum viewport height */
}

.main-bg{
  background: #250B6E;
}

.underBTN {
  font-size: 14px;
}

.bg-rightside {
  background-color: $PrimaryColor;
  min-height: 100vh; /* Altura mínima de la ventana gráfica */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.bg-rightside img {
  width: 60%;
}
.card-img-top{
  width: 350px !important;
  padding-bottom: 60px;
}

/* Estilos para dispositivos móviles */
@media (max-width: 767px) {
  .col-md-6.col-lg-6.col-xl-6 {
    flex: 1;
  }

  .d-none.d-md-flex {
    display: none !important;
  }

  .col-md-6{
    margin-top: 100px;
  }
}
</style>